<div class="tag-selector-header" *ngIf="label">
  <div class="tag-selector-header__lead">
    <span class="selector-label">{{ label }}</span>
    <ng-content select="[helper]"></ng-content>
  </div>
  <span class="tag-count">
    {{ selectedCount }}/{{ maxSelections }}
  </span>
</div>

<div class="tag-list" [attr.role]="describedBy ? 'group' : null" [attr.aria-describedby]="describedBy">
  <button
    *ngFor="let tag of tags; trackBy: trackByTag"
    type="button"
    class="tag-pill"
    [class.selected]="isSelected(tag)"
    [attr.aria-pressed]="isSelected(tag)"
    [style.background]="isSelected(tag) ? gradientVar(tag) : tintVar(tag)"
    (click)="toggle(tag)"
  >
    {{ tag.name }}
  </button>

  <button
    *ngIf="showAddCustomTag"
    type="button"
    class="tag-pill add-custom-tag"
    (click)="addCustomTag.emit()"
  >
    <svg-icon
      class="add-icon"
      src="assets/icons/icon-plus.svg"
      [svgStyle]="{ 'width.px': 9, 'height.px': 9 }"
    ></svg-icon>
    <span>ADD CUSTOM TAG</span>
  </button>
</div>
